import React, { FC } from 'react';
import cn from 'classnames';
import { BannerGroup, Theme, UniqueSellingPoints } from 'store/landing/types';
import Slider from 'react-slick';
import BigBannerGroup from '../BigBannerGroup/BigBannerGroup';
import LandingPageUniqueSellingPoints from '../LandingPageUniqueSellingPoints/LandingPageUniqueSellingPoints';
import styles from './LPHero.module.scss';

export interface LPHeroProps {
  bannerGroup?: BannerGroup;
  uniqueSellingPoints?: UniqueSellingPoints[];
  theme?: Theme;
}

const LPHero: FC<LPHeroProps> = ({ bannerGroup, uniqueSellingPoints, theme }) => {
  const [banner] = bannerGroup?.banners || [];

  const sliderCustomPaging = () => <div className="slick-dots--custom" />;

  return (
    <div
      className={cn(styles.lpHeroContainer, {
        [styles.shopifyContainer]: theme === 'shopify',
      })}
    >
      {theme !== 'shopify' && (
        <>
          {banner && (
            <BigBannerGroup
              entryId={banner.entryId}
              features={banner.features}
              height={bannerGroup?.height || 420}
              heightMobile={bannerGroup?.heightMobile || 400}
              h1={banner.h1}
              h1Color={banner.h1Color}
              h1ColorPhone={banner.h1ColorPhone}
              h1FontWeight={banner.h1FontWeight}
              h2={banner.h2}
              h2Color={banner.h2Color}
              h2ColorPhone={banner.h2ColorPhone}
              h2FontWeight={banner?.h2FontWeight}
              renderH1Desktop={banner.renderH1Desktop}
              renderH1Mobile={banner.renderH1Mobile}
              renderH2Desktop={banner.renderH2Desktop}
              renderH2Mobile={banner.renderH2Mobile}
              buttonLabel={banner.buttonLabel}
              buttonColor={banner.buttonColor}
              buttonBackgroundColor={banner.buttonBackgroundColor}
              buttonBorderColor={banner.buttonBorderColor}
              referenceUrl={banner.referenceUrl || ''}
              bannerImageUrl={banner.bannerImageUrl || ''}
              bannerImageUrlDesktop={banner.bannerImageUrlDesktop || ''}
              bannerImageUrlTablet={banner.bannerImageUrlTablet || ''}
              bannerImageUrlMobile={banner.bannerImageUrlMobile || ''}
              theme={(banner.theme as Theme) || ('default' as Theme)}
              headingTag="h1"
              appDownloadButtons={banner.appDownloadButtons}
            />
          )}
          {uniqueSellingPoints && <LandingPageUniqueSellingPoints uniqueSellingPoints={uniqueSellingPoints} />}
        </>
      )}
      {theme === 'shopify' && (
        <Slider dots arrows={false} autoplay autoplaySpeed={5000} customPaging={sliderCustomPaging}>
          {bannerGroup?.banners.map((b) => {
            return (
              <BigBannerGroup
                entryId={b.entryId}
                features={b.features}
                height={bannerGroup?.height || 420}
                heightMobile={bannerGroup?.heightMobile || 400}
                h1={b.h1}
                h1Color={b.h1Color}
                h1ColorPhone={b.h1ColorPhone}
                h1FontWeight={b.h1FontWeight}
                h2={b.h2}
                h2Color={b.h2Color}
                h2ColorPhone={b.h2ColorPhone}
                h2FontWeight={b?.h2FontWeight}
                renderH1Desktop={b.renderH1Desktop}
                renderH1Mobile={b.renderH1Mobile}
                renderH2Desktop={b.renderH2Desktop}
                renderH2Mobile={b.renderH2Mobile}
                buttonLabel={b.buttonLabel}
                buttonColor={b.buttonColor}
                buttonBackgroundColor={b.buttonBackgroundColor}
                buttonBorderColor={b.buttonBorderColor}
                referenceUrl={b.referenceUrl || ''}
                bannerImageUrl={b.bannerImageUrl || ''}
                bannerImageUrlDesktop={b.bannerImageUrlDesktop || ''}
                bannerImageUrlTablet={b.bannerImageUrlTablet || ''}
                bannerImageUrlMobile={b.bannerImageUrlMobile || ''}
                theme={(b.theme as Theme) || ('default' as Theme)}
                headingTag="h1"
                appDownloadButtons={b.appDownloadButtons}
              />
            );
          })}
        </Slider>
      )}
    </div>
  );
};

export default LPHero;
